
export default {
  name: 'GstCalculator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "Do all products come under GST?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Only processed, semi-processed, and packaged products are subject to the GST, which varies from 5% to 18%. Fresh food is exempt from GST."
        }
      },{
        "@type": "Question",
        "name": "Who has to pay GST?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "In general, suppliers of services and goods must pay GST. However, the recipients must be in charge of it in certain situations, such as imports and other registered goods."
        }
      },{
        "@type": "Question",
        "name": "Who can get the GST number?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Every company that sells goods with an annual revenue of more than INR 40 lakh is obliged to register as a regular taxpayer. If you own a company in the northeastern states of Himachal Pradesh, J&K, or Uttarakhand, the threshold limit will be INR 10 lakh."
        }
      },{
        "@type": "Question",
        "name": "Is GST compulsory for small businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, all small firms register for GST. If you manufacture products with an annual turnover of more than Rs. 40 Lakhs, you should consider obtaining a GST, no matter how big your business is."
        }
      },{
        "@type": "Question",
        "name": "Who is GST exempt?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "If the total annual revenue of the businesses and people supplying the items is lower than INR 40 lakhs, they are qualified for GST exemption."
        }
      },{
        "@type": "Question",
        "name": "How much GST do I charge?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "There are five GST rates: 0%, 5%, 12%, 18%, and 28%. Check for your state's regulations to determine which rate you will charge."
        }
      }]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        gst: 'exclusive',
        amount: null,
        rate: null
      })
    }
  },
  methods: {
    onGstCalculator() {
        this.form.post(`/tool/gst-calculator`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    },
    onSample(){
        this.form.amount = 100000;
        this.form.rate   = 6;
    },
    onReset(){
        this.form.reset();
        this.data = null;
    }
  }
}
